import { restClient } from '@/Core'

import { LETTER_REST_URL } from '../Contracts/ILetter'

import type { ILetter } from '../Contracts/ILetter'

/**
 * Картка листа з правами (`SPEC-013` §8, §11): `_permissions` вирішують, чи
 * лист редагують і чи є «Відправити».
 *
 * `forceRefresh`: ядровий клієнт дедуплікує GET на 30 с, а лист міг щойно
 * змінити статус (відправка, помилка SMTP).
 */
export const LoadLetterTask = async (uuid: string): Promise<ILetter> => {
    const raw = await restClient.get(`${LETTER_REST_URL}/${encodeURIComponent(uuid)}?permissions=true`, undefined, {
        forceRefresh: true,
    })

    if (raw === null || typeof raw !== 'object') throw new Error('Лист не знайдено.')

    return raw as unknown as ILetter
}
